import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { AssetRegisterImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/asset-register/asset-register-import-file-helper-container.model';
@Injectable({
  providedIn: 'root'
})
export class AssetRegisterFileHelperService extends BaseApiTemplateService<AssetRegisterImportFileHelperContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/import-file-hdr/helper/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/import-file-hdr/helper/backoffice-ep';;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }

}
